import Parse from 'parse'

class AuthAPI {
  async login(values: { email: string; password: string }) {
    const { email, password } = values
    const user = await Parse.User.logIn(email.toLowerCase(), password)
    return user
  }

  async signUp(values: { email: string; password: string }) {
    await Parse.Cloud.run('User_add', values)
    const user = await this.login({ email: values.email, password: values.password })
    return user
  }

  async logout() {
    await Parse.User.logOut()
  }

  async sendResetPasswordEmail(email: string) {
    await Parse.User.requestPasswordReset(email.toLowerCase())
  }

  async resetPassword(data: { newPassword: string; token: string; username: string }) {
    await Parse.Cloud.run('User_resetPassword', data)
  }

  async getCurrentUser() {
    const localUser = Parse.User.current()

    // we don't need to send request to the server if user is not logged-in
    if (!localUser) {
      return null
    }

    // only logged-in users hit the backend
    return await Parse.Cloud.run('User_getOne')
  }

  async getCurrentUserDefault(onlyCheckAuth = false, reload = false) {
    const user = Parse.User.current()
    if (!user) {
      return null
    }

    if (reload) {
      await user.fetch()
    }

    const { email, fullName, sessionToken } = user.attributes
    const userData = {
      id: user.id,
      email,
      fullName,
      sessionToken
    }

    if (onlyCheckAuth) {
      return userData
    }

    return {
      ...userData
    }
  }

  async checkExists(email: string): Promise<boolean> {
    return await Parse.Cloud.run('User_checkExists', { email })
  }

  async deleteAccount() {
    await Parse.Cloud.run('User_delete')
  }

  async dismissTooltip() {
    await Parse.Cloud.run('User_dismissTooltip')
  }

  async watchUnwatchEtf(etfId: string, watch: boolean) {
    await Parse.Cloud.run('User_watchUnwatchEtf', { etfId, watch })
  }

  async bookmarkUnbookmarkBlog(documentId: string, bookmark: boolean) {
    await Parse.Cloud.run('User_bookmarkUnbookmarkBlog', { documentId, bookmark })
  }
}

export default new AuthAPI()
